import { render, staticRenderFns } from "./BatchMovementPage.vue?vue&type=template&id=66c449e0"
import script from "./BatchMovementPage.vue?vue&type=script&lang=js"
export * from "./BatchMovementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports